import { captureException, startSpan } from "@sentry/react";

import { ILeaderboardDTO } from "../../types";
import { doGet } from "../core/http";

export const getLeaderboards = async (
    month?: string,
    year?: string
): Promise<ILeaderboardDTO[]> => {
    try {
        let url = "/api/v1/leaderboards";

        if (month !== "currentMonth" || year !== "currentYear") {
            if (month && year) {
                const formattedMonth = `${year}-${String(month).padStart(
                    2,
                    "0"
                )}`;
                url += `?month=${formattedMonth}`;
            }
        }

        const { data, error } = await startSpan(
            { name: "getLeaderboards" },
            () => {
                return doGet(url, false);
            }
        );

        if (error) {
            captureException(error);
            return [];
        }

        return data;
    } catch (e) {
        captureException(e);
        return [];
    }
};
